const InternalLayerValue = {
    'navigation-bar': 1000,
    'action-bar': 1000,
    drop: 1050,
    tooltip: 1100,
    'bottom-sheet': 1200,
    modal: 1200,
    snackbar: 300000,
};

export { InternalLayerValue };
//# sourceMappingURL=index.js.map
